// extracted by mini-css-extract-plugin
export default {"container":"style_container__Kide9","desc":"style_desc__NIthP","buttonWrapper":"style_buttonWrapper__YOETt","mobile":"style_mobile__DEmp-","desktop":"style_desktop__U5ljA"};